import React, { useState } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import styles from "./header.module.css"; // Your custom CSS module
import logo from "../../../assets/logo/logo2.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <Navbar
      id="header"
      className={`${styles.header} fixed-top ${isMenuOpen ? styles.mobileNavActive : ''}`}
      data-scrollto-offset="0"
      expand="lg"
    >
      <Container
        fluid
        className={`d-flex align-items-center  ${styles.containerHeader}`}
      >
        {/* Logo */}
        <Navbar.Brand
          href="https://diamond-aligner.com/patient.html"
          className={`${styles.logo} d-flex align-items-center scrollto me-auto me-lg-0`}
        >
          <img className={styles.logoImage} src={logo} alt="Diamond Aligner Logo" />
        </Navbar.Brand>

        {/* Burger Menu Toggle for Mobile */}
        <button
          className={styles.mobileNavToggle}
          onClick={toggleMenu}
        >
          <i className={`bi ${isMenuOpen ? "bi-x" : "bi-list"}`}></i>
        </button>

        {/* Navbar Links */}
        <div
          className={`${styles.navbar}`}
        >
          <Nav className="ms-auto">
            <Nav.Link
              href="https://diamond-aligner.com/doctor.html"
              className={`${styles.navLink} scrollto`}
            >
              A propos
            </Nav.Link>
            <Nav.Link
              href="https://diamond-aligner.com/doctor.html#patientjourney"
              className={`${styles.navLink} scrollto`}
            >
              Innovation
            </Nav.Link>
            <Nav.Link
              href="https://diamond-aligner.com/cases.html"
              className={`${styles.navLink} scrollto`}
            >
              Cas Traitables
            </Nav.Link>
            <Nav.Link
              href="#"
              className={`${styles.navLink} scrollto`}
            >
              Actus & Events 
            </Nav.Link>
            <Nav.Link
              href="https://diamond-aligner.com/assistance.html"
              className={`${styles.navLink} scrollto`}
            >
              Assistance professionelle 
            </Nav.Link>
           
          </Nav>
          <div className={styles.btnContainer}>
              <Button href="/getstarted" className={styles.btn1}>
                Get Started
              </Button>
              <Button href="/" className={styles.btn2}>
                Se connecter
              </Button>
            </div>
        </div>
      </Container>
    </Navbar>
  );
};

export default Header;